import React, { useEffect, useReducer, useState } from 'react'
import { get, post } from '../../config/fetch'

import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import CircularProgress from '@material-ui/core/CircularProgress'
import { Accordion, Tooltip } from '@material-ui/core'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Typography from '@material-ui/core/Typography'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import InputLabel from '@material-ui/core/InputLabel'
import DateFnsUtils from '@date-io/date-fns'
import { KeyboardDatePicker, KeyboardTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import AccessTimeIcon from '@material-ui/icons/AccessTime'
import TableContainer from '@material-ui/core/TableContainer'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import IconButton from '@material-ui/core/IconButton'
import CreateIcon from '@material-ui/icons/Create'
import DeleteIcon from '@material-ui/icons/Delete'
import TableHead from '@material-ui/core/TableHead'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import mapboxgl from 'mapbox-gl/dist/mapbox-gl-csp'
import SearchIcon from '@material-ui/icons/Search'
import TablePagination from '@material-ui/core/TablePagination'
import AlertWrapper from '../common/alert'
import Fab from '@material-ui/core/Fab'
import AddIcon from '@material-ui/icons/Add'
import { MoreVert } from '@material-ui/icons'
import CloseIcon from '@material-ui/icons/Close'
import Statistics from '../common/statistics'

const drawerWidth = 240
const MILLISECONDS = 60000;
const MILLISECONDS_HOURS = 3600000;
const MINUTES = 60;

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        background: 'black'
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        magin: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        backgroundColor: '#06171E',
    },
    paper2: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    fixedHeight: {
        height: 600,
    },
    fixedHeight2: {
        height: 135,
    },
    fixedHeight3: {
        height: 450,
    },
}))

const columns = [
    { id: 'msisdn', disablePadding: false, label: 'MSISDN' },
    { id: 'roaming', disablePadding: false, label: 'Forced Roaming' },
    { id: 'noRoaming', disablePadding: false, label: 'No Forced Roaming' },
    { id: 'percent', disablePadding: false, label: 'Percentage' },
    // { id: 'ci', disablePadding: false, label: 'CI' },
    // { id: 'tac', disablePadding: false, label: 'TAC' },
    // { id: 'cid', disablePadding: false, label: 'CID' },
    // { id: 'lac', disablePadding: false, label: 'LAC' },
    // { id: 'mcc', disablePadding: false, label: 'MCC' },
    // { id: 'mnc', disablePadding: false, label: 'MNC' },
    // { id: 'mobileNetworkOperator', disablePadding: false, label: 'Operator' },
    // { id: 'pci', disablePadding: false, label: 'PCI' },
    // { id: 'bandwidth', disablePadding: false, label: 'Bandwidth' },
    // { id: 'earfcn', disablePadding: false, label: 'Earfcn' },
    // { id: 'asuLevel', disablePadding: false, label: 'AsuLevel' },
    // { id: 'rsrp', disablePadding: false, label: 'RSRP' },
    // { id: 'rsrq', disablePadding: false, label: 'RSRQ' },
    // { id: 'rssi', disablePadding: false, label: 'RSSI' },
    // { id: 'rssnr', disablePadding: false, label: 'RSSNR' },
    // { id: 'cqi', disablePadding: false, label: 'CQI' },
    //{ id: 'lat-lng', disablePadding: false, label: 'Location' },
    { id: 'detail', disablePadding: false, label: 'Detail' },
    //{ id: 'longitud', disablePadding: false, label: 'Longitud' },
]

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}))(Tooltip);

const StyledTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.primary.background,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell)

const StyledTableRow = withStyles(theme => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow)

function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort } = props
    const createSortHandler = property => event => {
        onRequestSort(event, property)
    }

    return (
        <TableHead>
            <TableRow>
                {columns.map(headCell => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.align || 'left'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
}

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1
    }
    if (b[orderBy] > a[orderBy]) {
        return 1
    }
    return 0
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy)
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index])
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0])
        if (order !== 0) return order
        return a[1] - b[1]
    })
    return stabilizedThis.map(el => el[0])
}

export default function ForceRoaming() {
    const classes = useStyles()
    const [state, setState] = useReducer((s, a) => ({ ...s, ...a }), {
        error: null,
        loading: true,
        resolved: false,
        tickets: []
    });
    const [stateSearch, setStateSearch] = useReducer((s, a) => ({ ...s, ...a }), {
        input: '',
        loading: false,
    });
    
    const today = new Date()
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight)
    const fixedHeightPaper2 = clsx(classes.paper, classes.fixedHeight2)
    const fixedHeightPaper3 = clsx(classes.paper, classes.fixedHeight)

    const [order, setOrder] = useState('asc')
    const [orderBy, setOrderBy] = useState('calories')
    const [selected, setSelected] = useState([])
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(50)
    
    const [msisdn, setMsisdn] = useState('')
    const [startDate, setStartDate] = useState(
        new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0),
    )
    const [endDate, setEndDate] = useState(
        new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59),
    )
    
    const [isLoading, setLoading] = useState(true)
    const [isLoadingByDate, setLoadingByDate] = useState(true)
    const [visiblePopover, setVisiblePopover] = useState(true)
    const [visibleStatisticsModal, setVisibleStatisticsModal] = useState(false)
    const [detailTicket, setDetailTicket] = useState()
    
    /*
    useEffect(() => {
        //setLoading(true)
        fetchDevicesBrand();
    });

    useEffect(() => {
        fetchDevicesList();
    });
    */

    const findTickets = async () => {
        try {
            const startDateISO = new Date(startDate).toISOString()
            const endDateISO = new Date(endDate).toISOString()
            const url = `/forcedRoaming?startDate=${startDateISO}&endDate=${endDateISO}&msisdn=${msisdn}`;

            console.log('startDateISO: ', startDateISO)
            console.log('endDateISO: ', endDateISO)
            console.log('msisdn: ', msisdn)
            
            const { data: tickets } = await get(url)

            return tickets
        } catch (e) {
            throw new Error(e)
        }
    }

    useEffect( async () => {
        setStateSearch({
            ...state,
            loading: true,
        })
        findTickets()
            .then(response => {
                console.log('response', response)

                setStateSearch({
                    ...state,
                    loading: false,
                })
                setState({
                    ...state,
                    loading: false,
                    resolved: true,
                    tickets: response,
                })
            })
            .catch(e => {
                setState({
                    ...state,
                    loading: false,
                    error: e,
                })
            })
    }, []);
    
    const handleDate = async date => {
        setStartDate(date)
        const newEndDate = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            endDate.getHours(),
            endDate.getMinutes(),
        )
        setEndDate(newEndDate)
    }
    
    const handleChangeMsisdn = (event) => {
        setMsisdn(event.target.value)
    }

    const handleStartTime = date => {
        setStartDate(date)
    }

    const handleEndTime = date => {
        setEndDate(date)
    }
    
    const handleFilter = () => {
        console.log('Entre search', startDate)
        console.log('Entre search', endDate)
        console.log('Entre search', msisdn)

        
        setStateSearch({
            ...state,
            loading: true,
        })
        findTickets()
            .then(response => {
                console.log('response', response)

                setStateSearch({
                    ...state,
                    loading: false,
                })
                setState({
                    ...state,
                    loading: false,
                    resolved: true,
                    tickets: response,
                })
            })
            .catch(e => {
                setState({
                    ...state,
                    loading: false,
                    error: e,
                })
            })
    }

    const handleClickDetail = detail => {
        console.log('Entre en detalle: ', detail)
        setVisibleStatisticsModal(true)
        setDetailTicket(detail)
    }

    const handleChangeAccordion = () => {
        setVisiblePopover(!visiblePopover)
    }

    return (
        <Grid container spacing={0}>
            <Grid container direction="row" justify="flex-start" alignItems="flex-start">
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    container
                    direction="column"
                    justify="center"
                    alignItems="center"
                >
                    <Grid
                        item
                        xs={11}
                        sm={11}
                        md={11}
                        lg={11}
                        xl={11}
                        container
                        direction="row"
                        justify="space-between"
                        alignItems="center"
                        style={{ borderBottom: '1px solid' }}
                    >
                        <h2>Forced Roaming</h2>
                    </Grid>
                    <Grid
                        xs={11}
                        sm={11}
                        md={11}
                        lg={11}
                        xl={11}
                        container
                        direction="row"
                        justify="flex-start"
                        alignItems="center"
                        style={{ marginTop: '1em' }}
                    >
                        <Grid item xs={11} sm={11} md={11} lg={3} xl={4}>
                            <TextField
                                fullWidth
                                size="large"
                                id="standard-basic"
                                label="Search by MSISDN"
                                onChange={handleChangeMsisdn}
                                disabled={stateSearch.loading}
                            />
                        </Grid>
                        <Grid item xs={11} sm={11} md={11} lg={2} xl={4}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    id="date-picker-dialog"
                                    label="Filter date"
                                    format="MM/dd/yyyy"
                                    value={startDate}
                                    onChange={handleDate}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>

                        <Grid item xs={1} sm={1} md={1} lg={2} xl={2}>
                            {stateSearch.loading ? (
                                <CircularProgress color="inherit" />
                            ) : (
                                <IconButton
                                    type="submit"
                                    className={classes.iconButton}
                                    aria-label="search"
                                    onClick={handleFilter}
                                >
                                    <SearchIcon />
                                </IconButton>
                            )}
                        </Grid>
                        
                        
{/*
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={12} md={12}>
                                <Accordion expanded={visiblePopover} onChange={handleChangeAccordion}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel-header"
                                    >
                                        <Typography>Filters</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <InputLabel shrink id="msisdn-label">
                                                MSISDN
                                            </InputLabel>
                                            <TextField
                                                fullWidth
                                                size="large"
                                                id="msisdn"
                                                onChange={handleChangeMsisdn}
                                                value={msisdn}
                                                required={true}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <AccordionDetails className={classes}>
                                                    <KeyboardDatePicker
                                                        id="date-picker-dialog"
                                                        label="Filter date"
                                                        format="MM/dd/yyyy"
                                                        value={startDate}
                                                        onChange={handleDate}
                                                        KeyboardButtonProps={{
                                                            'aria-label': 'change date',
                                                        }}
                                                    />
                                                </AccordionDetails>
                                            </MuiPickersUtilsProvider>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <AccordionDetails className={classes}>
                                                    <KeyboardTimePicker
                                                        id="start-time-picker"
                                                        label="Start time"
                                                        value={startDate}
                                                        onChange={handleStartTime}
                                                        KeyboardButtonProps={{
                                                            'aria-label': 'change time',
                                                        }}
                                                        keyboardIcon={<AccessTimeIcon />}
                                                    />
                                                </AccordionDetails>
                                            </MuiPickersUtilsProvider>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <AccordionDetails className={classes}>
                                                    <KeyboardTimePicker
                                                        id="end-time-picker"
                                                        label="End time"
                                                        value={endDate}
                                                        onChange={handleEndTime}
                                                        KeyboardButtonProps={{
                                                            'aria-label': 'change time',
                                                        }}
                                                        keyboardIcon={<AccessTimeIcon />}
                                                    />
                                                </AccordionDetails>
                                            </MuiPickersUtilsProvider>
                                        </Grid>
                                        
                                        <Grid item xs={12} sm={6} md={3}>
                                            <Button size="small" color="primary" onClick={handleFilter}>
                                                Search
                                            </Button>
                                        </Grid>

                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                        </Grid>
*/}

                        {
                            stateSearch.loading ?
                                <></>
                                :
                                <>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} sm={12} md={12}>
                                            <Paper className={fixedHeightPaper3}>

                                                <TableContainer>
                                                    <Table
                                                        className={classes.table}
                                                        aria-labelledby="tableTitle"
                                                        size={'medium'}
                                                        aria-label="enhanced table"
                                                    >
                                                        <EnhancedTableHead
                                                            classes={classes}
                                                            numSelected={selected.length}
                                                            order={order}
                                                            orderBy={orderBy}
                                                            //onSelectAllClick={handleSelectAllClick}
                                                            //onRequestSort={handleRequestSort}
                                                            rowCount={state.tickets.length}
                                                        />
                                                        <TableBody>
                                                            {stableSort(state.tickets, getComparator(order, orderBy))
                                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                .map((row, index) => {
                                                                    return (
                                                                        <TableRow tabIndex={-1} key={row.id}>
                                                                            <TableCell>{row.msisdn || '-'}</TableCell>
                                                                            <TableCell>{row.roaming || '-'}</TableCell>
                                                                            <TableCell>{row.noRoaming || '-'}</TableCell>
                                                                            <TableCell>{ row.roaming ? (row.roaming / (row.roaming + row.noRoaming) * 100).toFixed(2) : '-' }</TableCell>
                                                                            <TableCell align="right">
                                                                                <IconButton aria-label="detail">
                                                                                    <MoreVert
                                                                                        onClick={() =>
                                                                                            handleClickDetail(row)
                                                                                        }
                                                                                    />
                                                                                </IconButton>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    )
                                                                })}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>

                                            </Paper>
                                        </Grid>
                                    </Grid>
                                </>
                        }
                        
                    </Grid>
                </Grid>
            </Grid>

            {visibleStatisticsModal && (
                <Paper
                    elevation={3}
                    style={{
                        position: 'absolute',
                        left: '350px',
                        top: '30%',
                        width: 'calc(100% - 900px)',
                        padding: '1em',
                        height: 'auto',
                        maxHeight: '80vh',
                        overflowY: 'auto',
                        background: 'rgba(1,1,1,0.9)',
                    }}
                >
                    <div
                        className="header-graphucs"
                        style={{ width: '100%', height: '4em', borderBottom: '1px solid #ccc' }}
                    >
                        <div>
                            <h1 style={{ margin: 0, textAlign: 'center' }}>Detail CID</h1>
                        </div>
                    </div>
                    <div style={{ position: 'absolute', top: 10, right: 10, zIndex: 3 }}>
                        <IconButton
                            aria-label="close"
                            color="default"
                            variant="contained"
                            type="button"
                            onClick={() => setVisibleStatisticsModal(false)}
                        >
                            <CloseIcon />
                        </IconButton>
                    </div>
                    <div style={{ margin: '1em 0' }}>
                        {
                            detailTicket ? 
                                <div>
                                    <TableContainer component={Paper}>
                                        <Table aria-label="customized table">
                                            <TableBody>
                                                <TableRow>
                                                    <StyledTableCell align="center">
                                                        <b>MSISDN</b> <br/> 
                                                        {detailTicket.msisdn}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="center">
                                                        <b>Type Network</b><br/>
                                                        {detailTicket.cidRoaming}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="center">
                                                        <b>CI</b><br/>
                                                        {detailTicket.cidNoRoaming}
                                                    </StyledTableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                                : <></>
                        }
                    </div>
                </Paper>
            )}
        </Grid>
        
        
    )
}
